document.addEventListener('Recharge::slot::mounted', (event) => {
  if (event.detail.name === 'footer' && event.detail.pathname === '/overview') {
    window?.yotpoWidgetsContainer?.initWidgets();
    window?.instafeedApp();
  }
});

if (!customElements.get('account-reviews')) {
  class AccountReviews extends HTMLElement {
    constructor() {
      super();
      this.sliderEl = this.querySelector('[data-slider]');

      this.sliderOptions = {
        spaceBetween: 8,
        navigation: {
          prevEl: this.querySelector('[data-prev-button]'),
          nextEl: this.querySelector('[data-next-button]'),
        },
        pagination: {
          el: this.querySelector('[data-pagination]'),
          clickable: true,
          type: 'bullets',
        },
        autoHeight: true,
      };
    }

    connectedCallback() {
      if (!this.sliderEl) {
        return;
      }
      this.initSlider();
    }

    initSlider() {
      this.slider = new Swiper(this.sliderEl, this.sliderOptions);
    }
  }

  customElements.define('account-reviews', AccountReviews);
}
